<template>
  <div>
    <div class="banner">
      <div class="banner-content">
        <img
          class="img-fluid"
          src="../assets/images/banner/ability_banner.jpg"
          alt="banner"
        />
        <div class="banner-text">
          <h1>核心課程能力測驗</h1>
          <div class="banner-text-line"></div>
          <span>Ability Test</span>
        </div>
      </div>
    </div>
    <div
      class="contentContainer-noMove"
      :style="{ backgroundImage: 'url(' + BG + ')' }"
    >
      <div class="content">
        <!-- mobile 用 -->
        <div
          v-if="screenWidth < 768"
          class="accordion mb-4 mt-4"
          id="insideMenuMobile"
        >
          <div class="card">
            <div class="card-header insideMenu-header" id="headingOne">
              <h2 class="mb-0">
                <button
                  class="btn btn-block text-left"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseOne"
                  aria-expanded="false"
                  aria-controls="collapseOne"
                >
                  {{ title }}
                  <i class="fas fa-angle-down fa-lg insideMenu-icon"></i>
                  <i class="fas fa-angle-up fa-lg insideMenu-icon"></i>
                </button>
              </h2>
            </div>

            <div
              id="collapseOne"
              class="collapse"
              aria-labelledby="headingOne"
              data-parent="#insideMenuMobile"
            >
              <div>
                <div class="list-group list-bg" id="list-tab" role="tablist">
                  <a
                    v-for="(item, index) in listTitle"
                    :key="index"
                    class="list-group-item text-center"
                    :class="{ active: title === item.titleZh }"
                    :id="item.titleEn"
                    data-toggle="list"
                    role="tab"
                    :aria-controls="item.titleEn"
                    @click="setTitle(item.titleZh)"
                    >{{ item.titleZh }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- PC 用 -->
        <div v-if="screenWidth >= 768" class="d-flex justify-content-center">
          <div
            class="
              list-group list-group-horizontal list-bg list-area
              rounded-pill
            "
            id="list-tab"
            role="tablist"
          >
            <a
              v-for="(item, index) in listTitle"
              :key="index"
              class="list-group-item text-center rounded-pill"
              :class="{ active: title === item.titleZh }"
              :id="item.titleEn"
              data-toggle="list"
              href="#list-announcement"
              role="tab"
              :aria-controls="item.titleEn"
              @click="setTitle(item.titleZh)"
              >{{ item.titleZh }}</a
            >
          </div>
        </div>
        <div class="tab-content" id="nav-tabContent">
          <div
            class="tab-pane fade show active"
            id="list-dentalHygienists"
            role="tabpanel"
            aria-labelledby="list-dentalHygienists-list"
          >
            <div class="content-title">
              <h2>{{ title }}</h2>
              <div class="bread">
                <router-link to="/">
                  <i class="fas fa-home fa-lg"></i>
                </router-link>
                <span>></span>
                核心課程能力測驗
              </div>
            </div>
            <transition-group mode="out-in">
              <!-- 共告事項分頁 -->
              <div v-if="title === '公告事項'" class key="transition1">
                <div class="announcement-wrap">
                  <div class="announcement-listArea">
                    <NewsList
                      v-for="(item, index) in filterList"
                      :key="index"
                      :data="item"
                      :from="'ability'"
                    ></NewsList>
                  </div>
                  <!-- <div class="announcement-filterArea">
                  <div class="announcement-searchBox">
                    <input type="text" v-model="searchString" />
                    <a href="#" @click.prevent="search(searchString)">
                      <i class="fas fa-search fa-lg"></i>
                    </a>
                  </div>
                  <div class="announcement-tag">
                    依年份搜尋
                    <ul class="announcement-tag-list list-unstyled">
                      <li>
                        <a href="#" class="filter-age" @click.prevent="filterAge('2020')">2020</a>
                      </li>
                      <li>
                        <a href="#" class="filter-age" @click.prevent="filterAge('2019')">2019</a>
                      </li>
                      <li>
                        <a href="#" class="filter-age" @click.prevent="filterAge('2018')">2018</a>
                      </li>
                    </ul>
                  </div>
                </div> -->
                </div>
              </div>
              <!-- 試題與解答分頁 -->
              <div v-if="title === '試題與解答'" class key="transition2">
                <div class="supervisory-btnBlock">
                  <template v-for="(item, index) in answerData">
                    <button
                      v-if="index === 0"
                      class="btn btn-supervisory active"
                      :key="'btnBlock' + index"
                      @click="setSupervisory(index)"
                      :data-id="index"
                    >
                      {{
                        item.title.replace(
                          "口腔衛生專業核心課程基本能力測驗",
                          ""
                        )
                      }}
                      試題與解答
                    </button>
                    <button
                      v-else
                      class="btn btn-supervisory"
                      :key="'btnBlock' + index"
                      @click="setSupervisory(index)"
                      :data-id="index"
                    >
                      {{
                        item.title.replace(
                          "口腔衛生專業核心課程基本能力測驗",
                          ""
                        )
                      }}
                      試題與解答
                    </button>
                  </template>
                </div>
                <div v-if="setList" class="supervisory-textBlock">
                  <div class="supervisory-textBlock-title">
                    <h3>{{ setList.title }}</h3>
                  </div>
                  <div class="supervisory-textBlock-table">
                    <ul class="ability-list list-unstyled">
                      <li v-for="(item, index) in setList.table" :key="index">
                        <a :href="item.Url" :download="`${item.title}.pdf`">
                          {{ item.title }}
                          <img src="../assets/images/icon/pdf.svg" alt="pdf" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- 推動小組名冊分頁 -->
              <div
                v-if="title === '推動小組名冊'"
                class="ability-roll"
                key="transition3"
              >
                <div class="supervisory-textBlock">
                  <div class="supervisory-textBlock-table">
                    <table>
                      <tr>
                        <td
                          class="
                            table-underline table-title
                            ability-table-underline
                          "
                          colspan="2"
                        >
                          擔任職務
                        </td>
                        <td
                          class="table-underline ability-table-underline"
                          colspan="2"
                        >
                          姓名
                        </td>
                        <td class="table-underline ability-table-underline">
                          服務單位及職稱
                        </td>
                      </tr>
                      <tr class="ability-table-gap"></tr>
                      <tr v-for="(item, index) in rollData" :key="index">
                        <td class="table-underline table-title ability-table">
                          {{ item.position }}
                        </td>
                        <td class="table-space"></td>
                        <td
                          class="
                            table-underline
                            ability-table ability-table-name
                          "
                        >
                          {{ item.name }}
                        </td>
                        <td class="table-space"></td>
                        <td class="table-underline ability-table">
                          {{ item.unit }} {{ item.title }}
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <!-- 口腔衛生總複習課程分頁 -->
              <div
                v-if="title === '口腔衛生總複習課程'"
                class
                key="transition4"
              >
                <div class="ability-review content-textBox">
                  <div
                    v-for="(item, index) in youtubeData"
                    :key="index"
                    class="ability-review-video"
                  >
                    <LazyYoutubeVideo
                      class="ability-review-youtube"
                      :src="item.url"
                    ></LazyYoutubeVideo>
                    <p>{{ item.date }}</p>
                    <h3>{{ item.title }}</h3>
                  </div>
                </div>
              </div>
              <!-- 其他純PDF下載分頁 -->
              <div v-else class="ability-listWrap" key="transition5">
                <ul class="ability-list list-unstyled">
                  <li v-for="(item, index) in filterData" :key="index">
                    <a :href="item.Url" :download="`${item.title}.pdf`">
                      {{ item.title }}
                      <img src="../assets/images/icon/pdf.svg" alt="pdf" />
                    </a>
                  </li>
                </ul>
              </div>
            </transition-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import LazyYoutubeVideo from 'vue-lazy-youtube-video';
import NewsList from '@/components/NewsList.vue';
import BG from '../assets/images/index_bg_big.png';
import 'vue-lazy-youtube-video/dist/style.css';

export default {
  name: 'Ability',
  components: {
    LazyYoutubeVideo,
    NewsList,
  },
  data() {
    return {
      BG,
      // screenWidth: 0,
      title: '公告事項',
      nowIndex: 0,
      searchString: '',
      listTitle: [
        {
          titleZh: '公告事項',
          titleEn: 'announcement',
        },
        {
          titleZh: '測驗通過名單',
          titleEn: 'passed',
        },
        {
          titleZh: '試題與解答',
          titleEn: 'answer',
        },
        {
          titleZh: '命題大綱',
          titleEn: 'proposition',
        },
        {
          titleZh: '推動小組名冊',
          titleEn: 'roll',
        },
        {
          titleZh: '口腔衛生總複習課程',
          titleEn: 'review',
        },
        {
          titleZh: '簡章下載',
          titleEn: 'download',
        },
      ],
      passedData: [
        {
          title: '114年度口腔衛生專業核心課程基本能力測驗通過名單',
          Url: '/static/pdf/passed/114年度口腔衛生專業核心課程基本能力測驗通過名單.pdf',
        },
        {
          title: '113年度口腔衛生專業核心課程基本能力測驗通過名單',
          Url: '/static/pdf/passed/113年度口腔衛生專業核心課程基本能力測驗通過名單.pdf',
        },
        {
          title: '112年度口腔衛生專業核心課程基本能力測驗通過名單',
          Url: '/static/pdf/passed/112年度口腔衛生專業核心課程基本能力測驗通過名單.pdf',
        },
        {
          title: '111年度口腔衛生專業核心課程基本能力測驗通過名單',
          Url: '/static/pdf/passed/111年度口腔衛生專業核心課程基本能力測驗通過名單.pdf',
        },
        {
          title: '107年度口腔衛生專業核心課程基本能力測驗通過名單',
          Url: '/static/pdf/passed/107年度口腔衛生專業核心課程基本能力測驗通過名單.pdf',
        },
        {
          title: '106年度口腔衛生專業核心課程基本能力測驗通過名單',
          Url: '/static/pdf/passed/106年度口腔衛生專業核心課程基本能力測驗通過名單.pdf',
        },
        {
          title: '105年度口腔衛生專業核心課程基本能力測驗通過名單',
          Url: '/static/pdf/passed/105年度口腔衛生專業核心課程基本能力測驗通過名單.pdf',
        },
      ],
      propositionData: [
        {
          title: '基礎口腔醫學',
          Url: '/static/pdf/proposition/基礎口腔醫學.pdf',
        },
        {
          title: '口腔預防保健',
          Url: '/static/pdf/proposition/口腔預防保健.pdf',
        },
        {
          title: '臨床口腔醫學',
          Url: '/static/pdf/proposition/臨床口腔醫學.pdf',
        },
        {
          title: '臨床口腔衛生學',
          Url: '/static/pdf/proposition/臨床口腔衛生學.pdf',
        },
      ],
      downloadData: [
        {
          title: '114年度口腔衛生專業核心課程基本能力測驗報名簡章',
          Url: '/static/pdf/114年度口腔衛生專業核心課程基本能力測驗報名簡章.pdf',
        },
        {
          title: '113年度口腔衛生專業核心課程基本能力測驗報名簡章',
          Url: '/static/pdf/113年度口腔衛生專業核心課程基本能力測驗報名簡章.pdf',
        },
        {
          title: '112年度口腔衛生專業核心課程基本能力測驗報名簡章',
          Url: '/static/pdf/112年度口腔衛生專業核心課程基本能力測驗報名簡章.pdf',
        },
        {
          title: '111年度口腔衛生專業核心課程基本能力測驗報名簡章',
          Url: '/static/pdf/111年度口腔衛生專業核心課程基本能力測驗報名簡章0217.pdf',
        },
      ],
      answerData: [
        {
          title: '114 年口腔衛生專業核心課程基本能力測驗',
          table: [
            {
              title: '口腔預防保健',
              Url: '/static/pdf/test/114年度/11401口腔預防保健答案.pdf',
            },
            {
              title: '臨床口腔衛生學',
              Url: '/static/pdf/test/114年度/11402牙科臨床口腔衛生試卷答案.pdf',
            },
            {
              title: '基礎口腔醫學',
              Url: '/static/pdf/test/114年度/11403基礎口腔醫學試卷答案.pdf',
            },
            {
              title: '臨床口腔醫學',
              Url: '/static/pdf/test/114年度/11404牙科醫療輔助學試卷答案.pdf',
            },
          ],
        },
        {
          title: '113 年口腔衛生專業核心課程基本能力測驗',
          table: [
            {
              title: '口腔預防保健',
              Url: '/static/pdf/test/113年度/11301口腔預防保健試卷.pdf',
            },
            {
              title: '臨床口腔衛生學',
              Url: '/static/pdf/test/113年度/11302臨床口腔衛生試卷.pdf',
            },
            {
              title: '基礎口腔醫學',
              Url: '/static/pdf/test/113年度/11303基礎口腔醫學試卷.pdf',
            },
            {
              title: '臨床口腔醫學',
              Url: '/static/pdf/test/113年度/11304臨床口腔醫學試卷.pdf',
            },
          ],
        },
        {
          title: '112 年口腔衛生專業核心課程基本能力測驗',
          table: [
            {
              title: '口腔預防保健',
              Url: '/static/pdf/test/112年度/11201口腔預防保健試卷.pdf',
            },
            {
              title: '臨床口腔衛生學',
              Url: '/static/pdf/test/112年度/11202臨床口腔衛生試卷.pdf',
            },
            {
              title: '基礎口腔醫學',
              Url: '/static/pdf/test/112年度/11203基礎口腔醫學試卷.pdf',
            },
            {
              title: '臨床口腔醫學',
              Url: '/static/pdf/test/112年度/11204臨床口腔醫學試卷.pdf',
            },
          ],
        },
        {
          title: '111 年口腔衛生專業核心課程基本能力測驗',
          table: [
            {
              title: '口腔預防保健',
              Url: '/static/pdf/test/111年度/111年度口腔預防保健.pdf',
            },
            {
              title: '臨床口腔衛生學',
              Url: '/static/pdf/test/111年度/111年度臨床口腔衛生學.pdf',
            },
            {
              title: '基礎口腔醫學',
              Url: '/static/pdf/test/111年度/111年度基礎口腔醫學.pdf',
            },
            {
              title: '臨床口腔醫學',
              Url: '/static/pdf/test/111年度/111年度臨床口腔醫學.pdf',
            },
          ],
        },
        {
          title: '107 年口腔衛生專業核心課程基本能力測驗',
          table: [
            {
              title: '口腔預防保健',
              Url: '/static/pdf/test/107年度/試題與解答/口腔預防保健.pdf',
            },
            {
              title: '臨床口腔衛生學',
              Url: '/static/pdf/test/107年度/試題與解答/臨床口腔衛生學.pdf',
            },
            {
              title: '基礎口腔醫學',
              Url: '/static/pdf/test/107年度/試題與解答/基礎口腔醫學.pdf',
            },
            {
              title: '臨床口腔醫學',
              Url: '/static/pdf/test/107年度/試題與解答/臨床口腔醫學.pdf',
            },
          ],
        },
        {
          title: '106 年口腔衛生專業核心課程基本能力測驗',
          table: [
            {
              title: '口腔預防保健',
              Url: '/static/pdf/test/106年度/試題與解答/口腔預防保健.pdf',
            },
            {
              title: '臨床口腔衛生學',
              Url: '/static/pdf/test/106年度/試題與解答/臨床口腔衛生學.pdf',
            },
            {
              title: '基礎口腔醫學',
              Url: '/static/pdf/test/106年度/試題與解答/基礎口腔醫學.pdf',
            },
            {
              title: '臨床口腔醫學',
              Url: '/static/pdf/test/106年度/試題與解答/臨床口腔醫學.pdf',
            },
          ],
        },
        {
          title: '105 年口腔衛生專業核心課程基本能力測驗',
          table: [
            {
              title: '口腔預防保健',
              Url: '/static/pdf/test/105年度/試題與解答/口腔預防保健.pdf',
            },
            {
              title: '臨床口腔衛生學',
              Url: '/static/pdf/test/105年度/試題與解答/臨床口腔衛生學.pdf',
            },
            {
              title: '基礎口腔醫學',
              Url: '/static/pdf/test/105年度/試題與解答/基礎口腔醫學.pdf',
            },
            {
              title: '臨床口腔醫學',
              Url: '/static/pdf/test/105年度/試題與解答/臨床口腔醫學.pdf',
            },
          ],
        },
      ],
      youtubeData: [
        {
          title: '口衛三總結課程 個案評估與照護器械(丁群展老師)',
          date: '20160531',
          url: 'https://youtu.be/ra3zMkmad0M',
        },
        {
          title: '口衛三總結課程 口腔衛生照護(劉彥君老師)',
          date: '20160526',
          url: 'https://youtu.be/XZQxh7gYUGw',
        },
        {
          title: '口衛三總結課程 特殊需求者口腔衛生照護(黃純德老師)',
          date: '20160524',
          url: 'https://youtu.be/IGP2yu9QJTQ',
        },
        {
          title: '口衛三總結課程 口腔營養學(黃孟娟老師)',
          date: '20160517',
          url: 'https://youtu.be/u9haswABaKM',
        },
        {
          title: '口衛三總結課程 口腔健康促進、疾病預防與控制策略(黃曉靈老師)',
          date: '20160517',
          url: 'https://youtu.be/nDHyy42Xt1E',
        },
        {
          title: '口衛三總結課程 口腔組織與胚胎學(劉彥君老師)',
          date: '20160516',
          url: 'https://youtu.be/JV7oLl09ZDc',
        },
        {
          title: '口衛三總結課程 社區口腔衛生計畫與實務(何佩珊老師) part1',
          date: '20160505',
          url: 'https://youtu.be/kVwaPEhf884',
        },
        {
          title: '口衛三總結課程 社區口腔衛生計畫與實務(何佩珊老師) part2',
          date: '20160505',
          url: 'https://youtu.be/yUm22cI5DlU',
        },
        {
          title: '口衛三總結課程 牙周病學(吳逸民老師) part1',
          date: '20160503',
          url: 'https://youtu.be/7jyqDm_WXQE',
        },
        {
          title: '口衛三總結課程 牙周病學(吳逸民老師) part2',
          date: '20160503',
          url: 'https://youtu.be/7jyqDm_WXQE',
        },
        {
          title: '口衛三總結課程 衛生政策與管理(林子賢老師) part1',
          date: '20160426',
          url: 'https://youtu.be/vycUvdnfT1E',
        },
        {
          title: '口衛三總結課程 衛生政策與管理(林子賢老師) part2',
          date: '20160426',
          url: 'https://youtu.be/MQlg0EvYoLY',
        },
        {
          title: '口衛三總結課程 牙體型態學(丁群展老師)',
          date: '20160412',
          url: 'https://youtu.be/wHI1zoOc_7A',
        },
        {
          title: '口衛三總結課程 口腔病理學(陳玉昆老師)',
          date: '20160329',
          url: 'https://youtu.be/0oPNsjLteok',
        },
        {
          title: '口衛三總結課程 口腔放射線學(陳玉昆老師) part1',
          date: '20160322',
          url: 'https://youtu.be/G9zNyzIDX0c',
        },
        {
          title: '口衛三總結課程 口腔放射線學(陳玉昆老師) part2',
          date: '20160322',
          url: 'https://youtu.be/yvYcmgK5MRc',
        },
        {
          title: '口衛三總結課程-口腔解剖與生理學(柯政全老師)',
          date: '20160308',
          url: 'https://youtu.be/WZrmvxwu2to',
        },
        {
          title: '口衛三總結課程-口腔微生物與免疫學(林英助老師)',
          date: '20160223',
          url: 'https://youtu.be/L4Ci_iLpbac',
        },
      ],
      rollData: [
        {
          position: '總召集人',
          name: '何佩珊',
          unit: '高雄醫學大學',
          title: '口腔衛生學系系主任',
        },
        {
          position: '基礎口腔醫學召集人',
          name: '許瀚仁',
          unit: '高雄醫學大學',
          title: '口腔衛生學系助理教授',
        },
        {
          position: '副召集人',
          name: '林穎志',
          unit: '仁德醫護管理專科學校',
          title: '口腔衛生學科副教授',
        },
        {
          position: '副召集人',
          name: '藍文謙',
          unit: '德育護理健康學院',
          title: '口腔衛生照護系副教授',
        },
        {
          position: '口腔預防保健召集人',
          name: '劉秀月',
          unit: '高雄醫學大學',
          title: '口腔衛生學系副教授',
        },
        {
          position: '副召集人',
          name: '陳立昇',
          unit: '臺北醫學大學',
          title: '口腔衛生學系教授',
        },
        {
          position: '副召集人',
          name: '林盈諄',
          unit: '樹人醫護管理專科學校',
          title: '口腔衛生學科助理教授',
        },
        {
          position: '臨床口腔醫學召集人',
          name: '吳如惠',
          unit: '高雄醫學大學',
          title: '口腔衛生學系副教授',
        },
        {
          position: '副召集人',
          name: '黃茂栓',
          unit: '臺北醫學大學',
          title: '口腔衛生學系教授',
        },
        {
          position: '副召集人',
          name: '涂筱培',
          unit: '新生醫護管理專科學校',
          title: '口腔衛生學科助理教授',
        },
        {
          position: '臨床口腔衛生學召集人',
          name: '邱思瑜',
          unit: '樹人醫護管理專科學校',
          title: '口腔衛生學科助理教授',
        },
        {
          position: '副召集人',
          name: '孫鼎茂',
          unit: '樹人醫護管理專科學校',
          title: '口腔衛生學科助理教授',
        },
        {
          position: '副召集人',
          name: '江典澄',
          unit: '仁德醫護管理專科學校',
          title: '口腔衛生學科助理教授',
        },
      ],
      list: [
        {
          Id: '6',
          CreatedOn: '2025-06-23',
          EndOn: '',
          Title: '【114年度口腔衛生專業核心課程基本能力測驗】考試試題與答案',
          Content: '<h3><span style="font-size:x-large;">本次核心課程基本能力測驗之試題與答案，已上傳至試題與解答專區，請考生自行閱讀。</span></h3>',
        },
        {
          Id: '5',
          CreatedOn: '2024-07-30',
          EndOn: '',
          Title: '【113年度口腔衛生專業核心課程基本能力測驗】考試試題與答案',
          Content: '<h3><span style="font-size:x-large;">本次核心課程基本能力測驗之試題與答案，已上傳至試題與解答專區，請考生自行閱讀。</span></h3><h3><span style="font-size:x-large;">本學會核心課程基本能力測驗推動小組，針對題目有所爭議處，考量後該題目以送分方式進行處理。</span></h3><h3><span style="font-size:x-large;">送分題目為：<br>考科：口腔預防保健&nbsp;&nbsp;&nbsp;題目：第52題</span></h3>',
        },
        {
          Id: '3',
          CreatedOn: '2023-07-19',
          EndOn: '',
          Title: '【112年度口腔衛生專業核心課程基本能力測驗】考試試題與答案',
          Content: '<h3><span style="font-size:x-large;">本次核心課程基本能力測驗之試題與答案，已上傳至試題與解答專區，請考生自行閱讀。</span></h3><h3><span style="font-size:x-large;">本學會核心課程基本能力測驗推動小組，針對題目有所爭議處，考量後該題目以送分方式進行處理。</span></h3><h3><span style="font-size:x-large;">送分題目為：<br>考科：口腔預防保健&nbsp;&nbsp;&nbsp;題目：第05題</span></h3>',
        },
        {
          Id: '4',
          CreatedOn: '2023-07-19',
          EndOn: '',
          Title: '【112年度口腔衛生專業核心課程基本能力測驗】成績公告事宜',
          Content: '<h3><span style="font-size:x-large;">感謝各位考生參與本年度核心課程基本能力測驗，本會預定於</span><strong><span style="color:#ff0000;font-size:x-large;">考試後一個月</span></strong><span style="font-size:x-large;">以<strong>電子檔</strong>寄送至各位考生</span><span style="color:#ff0000;font-size:x-large;">電子郵件</span><span style="font-size:x-large;">信箱，在煩請各位考生留意。</span></h3>',
        },
        {
          Id: '1',
          CreatedOn: '2022-06-06',
          EndOn: '',
          Title: '【111年度口腔衛生專業核心課程基本能力測驗】成績公告事宜',
          Content: '<h3><span style="font-size:x-large;">感謝各位考生參與本年度核心課程基本能力測驗，本會預定於</span><strong><span style="color:#ff0000;font-size:x-large;">考試後一個月</span></strong><span style="font-size:x-large;">以<strong>電子檔</strong>寄送至各位考生</span><span style="color:#ff0000;font-size:x-large;">電子郵件</span><span style="font-size:x-large;">信箱，在煩請各位考生留意。</span></h3><h3><span style="font-size:x-large;">因COVID-19疫情無法應考之考生，並於111年5月22日以前提出申請者，本會預定於一個月完成退款手續，並透過電子郵件通知退款進度。</span></h3>',
        },
        {
          Id: '2',
          CreatedOn: '2022-06-09',
          EndOn: '',
          Title: '【111年度口腔衛生專業核心課程基本能力測驗】考試試題與答案',
          Content: '<h3><span style="font-size:x-large;">本次核心課程基本能力測驗之試題與答案，已上傳至試題與解答專區，請考生自行閱讀。</span></h3><h3><span style="font-size:x-large;">本學會核心課程基本能力測驗推動小組，針對題目有所爭議處，考量後該題目以送分方式進行處理。</span></h3><h3><span style="font-size:x-large;">送分題目為：<br>考科：基礎口腔醫學&nbsp;&nbsp;&nbsp;題目：第31題<br>考科：臨床口腔醫學&nbsp;&nbsp;&nbsp;題目：第59題</span></h3>',
        },
        // {
        //   Id: 'ability',
        //   CreatedOn: '2019-01-07',
        //   EndOn: '',
        //   Title: '107年度口腔衛生專業核心課程基本能力測驗 准考證已於4/18(三)以中華郵政掛號寄出，請考生留意!(高醫口衛系在校生的准考證於考前二週再統一發放)。',
        // },
        // {
        //   Id: 'ability',
        //   CreatedOn: '2019-01-07',
        //   EndOn: '',
        //   Title: '107年度口腔衛生專業核心課程基本能力測驗 准考證已於4/18(三)以中華郵政掛號寄出，請考生留意!(高醫口衛系在校生的准考證於考前二週再統一發放)。',
        // },
      ],
    };
  },
  methods: {
    setTitle(text) {
      const vm = this;
      vm.title = text;
      $('#collapseOne').collapse('hide');
    },
    setSupervisory(index) {
      const vm = this;
      $('.btn-supervisory').removeClass('active');
      // eslint-disable-next-line no-restricted-globals
      $(event.target).addClass('active');
      // eslint-disable-next-line no-restricted-globals
      // console.log(event.target.getAttribute('data-id'), index, event.target);
      vm.nowIndex = index;
    },
    getVideoUrl() {
      const vm = this;
      // vm.isYoutube = true;
      for (let i = 0; i < vm.youtubeData.length; i += 1) {
        const tmpUrl = vm.youtubeData[i].url.replace('https://youtu.be/', '');
        vm.youtubeData[
          i
        ].url = `https://www.youtube-nocookie.com/embed/${tmpUrl}`;
      }
    },
    filterAge(age) {
      // const vm = this;
      $('.filter-age').removeClass('active');
      // eslint-disable-next-line no-restricted-globals
      $(event.target).addClass('active');
      // console.log(age);
    },
    search(string) {
      if (string === '') {
        // console.log('空的');
      } else {
        // console.log(string);
      }
    },
  },
  created() {
    // this.screenWidth = window.innerWidth;
    this.getVideoUrl();
  },
  computed: {
    filterData() {
      const vm = this;
      let returnData = [];
      if (vm.title === '測驗通過名單') {
        returnData = vm.passedData;
      } else if (vm.title === '命題大綱') {
        returnData = vm.propositionData;
      } else if (vm.title === '簡章下載') {
        returnData = vm.downloadData;
      }
      return returnData;
    },
    filterList() {
      const vm = this;
      let returnData = [];
      if (vm.searchString !== '') {
        returnData = vm.list.filter(
          (item) => item.Title.indexOf(vm.searchString) !== -1,
        );
      } else {
        returnData = vm.list;
      }
      return returnData;
    },
    setList() {
      const vm = this;
      return vm.answerData[vm.nowIndex];
    },
    screenWidth() {
      return this.$store.state.screenWidth;
    },
  },
};
</script>

<style lang="scss">
.list-bg {
  a {
    cursor: pointer;
  }
}
</style>
